export const arrow_right = {
	name: 'arrow-right',
	title: 'Arrow Right',
	content:
		'<path d="M 5.5,0.75l10.72,10.72c0.293,0.292,0.293,0.767,0.001,1.059c0,0-0.001,0.001-0.001,0.001L5.5,23.25" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
};
